<template>
  <div class="of-h" v-loading="loading">
    <div class="flex-box al-c card-title">
      <i class="myfont icon-gongju"></i>
      <span class="font-20">工具</span>
    </div>

    <el-row class="w100" v-loading="loading">
      <el-col :span="col" v-for="(item, index) in list" :key="index">
        <a class="block w100 pt20 cu-p tx-c app-item" target="_blank" :href="item.toolUrl">
          <img class="app-img" :src="item.toolIcon ? item.toolIcon : `${baseUrl}images/icon-app.png`" style="width: 60px; height: 60px; border-radius: 50%;">
          <!-- <el-image class="app-img" :src="item.toolIcon" lazy style="width: 60px; height: 60px; border-radius: 50%;">
            <img :src="`${baseUrl}images/icon-app.png`" width="60" height="60" slot="error">
          </el-image> -->
          <p class="mt10 pl20 pr20 font-14 ellipsis">{{ item.toolName }}</p>
        </a>
      </el-col>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无工具</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CardTool",
  components: {},
  props: ["w", "h"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      list: [],

      col: 8
    };
  },
  computed: {
    pageSize() {
      return this.w * 3 * (this.h * 2);
    }
  },
  created() {
    this.fetchList();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "/tool/toolPermitList",
          this.$qs.stringify({
            pageNum: 1,
            pageSize: this.pageSize
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.$nextTick(() => {
              this.computeCol();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 每次获取计算列个数
    computeCol() {
      switch (this.w) {
        case 1:
          this.col = 8;
          break;
        case 2:
          this.col = 4;
          break;
        case 3:
          this.col = 3;
          break;
        default:
          break;
      }
    },
    resizedEvent() {
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.card-title {
  height: 40px;
}

.card-title i {
  color: #619df8;
  font-size: 20px;
  margin-left: 10px;
  margin-right: 5px;
}

.app-item {
  height: 140px;
}

.app-item:hover {
  background: #edf5fe;
}
.app-img {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>
